import React from "react";

const SecondaryActionCard = ({ heading, subheading, cta, link }) => {
  return (
    <div className="dashboard__container__content__section__secondary">
      <h3 className="dashboard__container__content__section__secondary__heading">
        {heading}
      </h3>
      <p className="dashboard__container__content__section__secondary__paragraph">
        {subheading}
      </p>
      <a href={link}>
        <button className="btn btn-md dashboard__container__content__section__secondary__button">
          {cta}
        </button>
      </a>
    </div>
  );
};

export default SecondaryActionCard;
